<!-- TOOLBAR -->
<mw-app-toolbar
  *ngIf="config.layout.toolbar.show && !config.isShellApp"
  [showToggler]="showToggler && !emptyList"
  [showCompactLogo]="showCompactLogo"
  [showFullScreenButton]="showFullScreenButton"
  [clickableTitle]="options?.clickableTitle"
></mw-app-toolbar>
<div
  class="mw-layout"
  [ngClass]="{
    'mw-layout--full-width': fullWidth,
    'mw-layout--fixed-width': !fullWidth,
    'mw-layout--no-paddings': noPaddings
  }"
>
  <mw-sidebar
    #navSidebarRef
    *ngIf="
      !hideNavBar &&
      !emptyList &&
      config.layout.navbar.show &&
      (userHasAccessToModule$ | async)
    "
    [name]="SidebarId.Navigation"
    position="left"
    [lockedOpen]="true"
    [folded]="navBarFolded"
    [foldedWidth]="navBarFoldedWidth"
    (foldedChange)="onNavSidebarFoldChanged($event)"
    mwPerfectScrollBar
  >
    <mw-nav-list
      [sidebarFolded]="navBarFolded"
      (scrollToTop)="perfectScrollNav.scrollToTop($event)"
      (opened)="navItemToggled()"
    ></mw-nav-list>
  </mw-sidebar>

  <div class="mw-layout__content" mwPerfectScrollBar #layoutScrollBar>
    <router-outlet></router-outlet>
  </div>

  <mw-sidebar
    [name]="SidebarId.News"
    position="right"
    [width]="336"
    class="mw-layout__sidebar"
    *ngIf="showNewsButton && !config.isShellApp"
  >
    <mw-news></mw-news>
  </mw-sidebar>

  <mw-sidebar
    [name]="SidebarId.AppModules"
    position="right"
    [width]="336"
    class="mw-layout__sidebar"
    *ngIf="showModuleButton && !config.isShellApp"
  >
    <mw-app-modules></mw-app-modules>
  </mw-sidebar>

  <mw-sidebar
    [name]="SidebarId.ProfileMenu"
    position="right"
    [width]="336"
    class="mw-layout__sidebar"
    *ngIf="!config.isShellApp"
  >
    <mw-profile-menu></mw-profile-menu>
  </mw-sidebar>
</div>
